import {
  AsyncMessageTypes,
  type ChatMessage,
  MessageModelType,
  MessageTag,
} from "../types/chatMessageTypes";

/**
 * Checks if a message is a system message
 *
 * @param message - The chat message to check
 * @returns Boolean indicating if the message is a system message
 */
export const isSystemMessage = (message: ChatMessage): boolean => {
  return (
    message.tag !== MessageTag.CUSTOMER &&
    message.tag !== MessageTag.PROFESSIONAL &&
    message.type !== AsyncMessageTypes.TEXT &&
    message.modelType !== MessageModelType.ASYNC_MESSAGE
  );
};
